<template>
	<div class="row content-block">
		<div class="col-12 col-lg-12">
			<div class="content" v-html="content.ru" />
		</div>
	</div>
</template>

<script>
export default {
	name: 'PanelWysiwyg',
	props: [
		'content',
		'static_content',
		'block_title',
		'fetchedData',
	],
};
</script>

<style scoped lang="scss">
//.content {
//	&::after {
//		content: '';
//		display: block;
//		height: 80%;
//		max-height: 550px;
//		left: -15px;
//		right: -15px;
//		position: absolute;
//		pointer-events: none;
//		z-index: 10;
//		bottom: 0;
//		background: linear-gradient(to top,#fff 0,rgba(255,255,255,.9) 70%,rgba(255,255,255,0) 100%);
//	}
//}
</style>
